/* eslint-disable quotes */
/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import {
  connect, useDispatch, useSelector
} from "react-redux";
import {
 Container, Spinner
} from "reactstrap";
import MetaTags from "react-meta-tags";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import CardWrapper from "../../components/Common/CardWrapper";
import DocumentsList from "./DocumnetsList";
import DocumentUpload from "./DocumentsUpload";
import DocumentsCorpUpload from "./DocumentsCorpUpload";
import Sumsub from "./Sumsub";

import { fetchDocsStart } from "../../store/general/documents/actions";
import documentJourneyValidation from "common/helpers";

function Documents(props) {
  const dispatch = useDispatch();

  // Redux states
  const clientData = useSelector((state) => state.Profile.clientData);
  const { loading } = useSelector((state) => state.documents);
  const { subPortal } = useSelector((state) => state.Layout);

  // Local state
  const [showKYC, setShowKYC] = useState(true);

  // 🔹 Fetch general documents
  const loadDocs = () => {
    dispatch(fetchDocsStart());
  };

  useEffect(() => {
    loadDocs(props.token);
  }, [props.uploading]);

  if (documentJourneyValidation(clientData, subPortal) !== true) {
    return (
      <div className="page-content">
        <MetaTags>
          <title>{props.t("Documents")}</title>
        </MetaTags>
        {loading ? (
          <div className="d-flex align-items-center justify-content-center mt-5">
            <Spinner />
          </div>
        ) : (
          <Container>
            <CardWrapper className="mt-5 glass-card shadow">
              <div className="d-flex align-items-center justify-content-center color-primary">
                <Link to="/dashboard">
                  {props.t("Please complete journey stages before upload documents")}
                </Link>
              </div>
            </CardWrapper>
          </Container>
        )}
      </div>
    );
  }

  // 🔹 Optional: enable Sumsub flow
  const enableSumSub = true;
  if (enableSumSub) {
    return (
      <div className="page-content">
        <MetaTags>
          <title>{props.t("Documents")}</title>
        </MetaTags>
        <Container>
          <div className="profile mt-5 h-full">
            <Sumsub />
          </div>
        </Container>
      </div>
    );
  }

  return (
    <>
      <div className="page-content">
        <MetaTags>
          <title>{props.t("Documents")}</title>
        </MetaTags>

        <Container>
          <div className="profile mt-5">
            {/* Header */}
            <h1 className="mb-4 color-primary">{props.t("My Documents")}</h1>

            {/* List of existing documents */}
            <CardWrapper className="mb-5 my-document glass-card shadow">
              <DocumentsList />
            </CardWrapper>

            {/* Upload new document header + Kuwait KYC actions */}
            <div className="mb-4 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <h1 className="color-primary mb-0">
                {props.t("Upload New Document")}
              </h1>
            </div>
            <div className="upload-document mb-5">
              {clientData?.isCorporate ? (
                <DocumentsCorpUpload />
              ) : (
                <DocumentUpload setShowKYC={setShowKYC} />
              )}
            </div>
          </div>
        </Container>
      </div>

    </>
  );
}

const mapStateToProps = (state) => ({
  documents: state.documents.documents,
  uploading: state.documents.uploading,
});

export default connect(mapStateToProps)(withTranslation()(Documents));
